import { StripeAddressElementChangeEvent, StripeAddressElementOptions } from '@stripe/stripe-js';

import { BillingAddress } from '@web/account/types';

export function mapFormValuesToBillingAddress(
  formValues: StripeAddressElementChangeEvent['value']
): BillingAddress {
  const {
    country: countryCode,
    state: regionCode,
    postal_code: postalCode,
    line2,
    ...address
  } = formValues.address;

  return {
    fullName: formValues.name,
    countryCode,
    regionCode,
    postalCode,
    line2,
    ...address,
  };
}

export function mapBillingAddressToFormValues(
  billingAddress: BillingAddress | null
): StripeAddressElementOptions['defaultValues'] | null {
  if (!billingAddress) {
    return null;
  }

  return {
    name: billingAddress.fullName,
    address: {
      line1: billingAddress.line1,
      line2: billingAddress.line2,
      country: billingAddress.countryCode,
      state: billingAddress.regionCode,
      postal_code: billingAddress.postalCode,
      city: billingAddress.city,
    },
  };
}
